import { render, staticRenderFns } from "./NormasFormList.vue?vue&type=template&id=73b60200&"
import script from "./NormasFormList.vue?vue&type=script&lang=js&"
export * from "./NormasFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports